import { CLessonInCourse } from '@yandex-int/k-common/typings/api/defs/lesson/clesson';
import { format, fromUnixTime } from 'date-fns';
import { CalendarIntervalDay } from 'platform-components';

import {
    CalendarCardType,
    CalendarClessons,
    CourseCalendarColumnsCard,
    CourseCalendarMarkedClesson,
    MarkedMonthDays,
} from './typings';
import { getMonthIntervalId } from './utils';

export const mapPeriodLessons = (
    data: { result: Record<string, CLessonInCourse[]> }[],
    interval: CalendarIntervalDay[],
    courseIds: number[]
) => {
    const cardsByDate: Record<string, CourseCalendarColumnsCard[]> = {};
    const clessons: CalendarClessons = {};
    const clessonList: CLessonInCourse[] = [];

    interval.forEach(({ date, timestamp }) => {
        if (!cardsByDate[date]) {
            cardsByDate[date] = [];
        }

        data.forEach(({ result }, courseIndex) => {
            result[timestamp]?.forEach((item) => {
                clessonList.push(item);
                clessons[item.id] = {
                    courseId: courseIds[courseIndex],
                    clesson: item,
                };
                cardsByDate[date].push({
                    cardId: item.id,
                    cardType: CalendarCardType.CLESSON,
                });
            });
        });
    });

    return { cardsByDate, clessons, clessonList };
};

export const mapMonthCoursesLessons = (
    data: CourseCalendarMarkedClesson[][],
    interval: CalendarIntervalDay[]
): MarkedMonthDays => {
    const start = interval[0].date;
    const end = interval[interval.length - 1].date;
    const markedDays: Record<string, CourseCalendarMarkedClesson[]> = {};

    data.forEach((clessons) => {
        clessons.forEach((clesson) => {
            const currentDate = format(fromUnixTime(clesson.date), 'yyyy-MM-dd');

            if (markedDays[currentDate]) {
                markedDays[currentDate].push(clesson);
            } else {
                markedDays[currentDate] = [clesson];
            }
        });
    });

    return { [getMonthIntervalId(start, end)]: markedDays };
};
